import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star, EyeOff, Eye } from "lucide-react";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const [replying, setReplying] = useState({});
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);

  const submitReply = async (id) => {
    await api.patch(`/admin/reviews/${id}/reply`, { reply: replying[id] || "" });
    toast.success("Reply saved"); load();
  };
  const toggle = async (id) => { await api.patch(`/admin/reviews/${id}/toggle-hidden`); load(); };

  return (
    <div>
      <header className="mb-6">
        <div className="text-xs uppercase tracking-widest text-gray-400">Feedback</div>
        <h1 className="font-display text-2xl font-bold tracking-tight mt-1">Reviews</h1>
      </header>
      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} data-testid={`review-${r.id}`} className="qd-admin-card p-5">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-semibold">{r.customer_name}</div>
                <div className="flex items-center gap-1 mt-1">
                  {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= r.average ? "fill-[var(--qd-primary)] text-[var(--qd-primary)]" : "text-gray-200"}`} />)}
                  <span className="ml-2 text-xs text-gray-400">Food {r.food_rating} · Service {r.service_rating} · Ambience {r.ambience_rating}</span>
                </div>
                {r.comment && <p className="text-sm text-gray-700 mt-2">{r.comment}</p>}
              </div>
              <button data-testid={`review-toggle-${r.id}`} onClick={() => toggle(r.id)} className="text-gray-400 hover:text-gray-700">{r.is_hidden ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
            </div>
            {r.reply && <div className="mt-3 p-3 bg-gray-50 rounded-lg text-sm"><span className="text-xs text-gray-400 uppercase tracking-widest">Reply</span><br />{r.reply}</div>}
            <div className="mt-3 flex gap-2">
              <Textarea data-testid={`review-reply-input-${r.id}`} value={replying[r.id] || ""} onChange={(e) => setReplying({ ...replying, [r.id]: e.target.value })} placeholder="Public reply…" className="min-h-[40px] text-sm" />
              <Button data-testid={`review-reply-btn-${r.id}`} onClick={() => submitReply(r.id)} size="sm" className="bg-[var(--qd-charcoal)] hover:bg-black">Reply</Button>
            </div>
          </div>
        ))}
        {reviews.length === 0 && <div className="text-sm text-gray-400 p-8 text-center">No reviews yet</div>}
      </div>
    </div>
  );
}
